import React from "react";
import { useEffect } from "react";
import Hero from "../../components/home/hero/hero";
import HeroImg from "../../components/home/hero/image";


import About from "../../components/home/about";
import Skill from "../../components/home/skill";
import Services from "../../components/home/services";
import Projects from "../../components/home/projects";
import Summary from "../../components/home/summary";
import Contact from "../../components/home/contact";
import Testimonials from "../../components/home/testimonial";
const Home = () => {
        console.log("Home component is rendered");
useEffect(()=>{
        document.title ="Udoka | Home"
})
    return (
        <div className="py-4 px-4">


<div className="flex flex-col md:flex-row space-y-4 md:space-x-8 md:space-y-0 w-full h-[600px]  md:h-[550px]">

        <Hero />
        <HeroImg/>
       

</div>
<About/>
<Skill/>
<Services/>
<Projects/>
<Summary/>
<Testimonials/>
<Contact/>

        {/* <div className="w-full flex flex-wrap justify-center items-center md:space-x-8 md:space-y-0 space-y-8">   
</div> */}


    </div>
    );
}

export default Home;